import React, { useEffect, useState } from "react";
import {
    Main,
    ContenedorTitulo,
    Titulo,
} from "../TestMapa/AlcantarillaElements";

import {
    Box,
    Grid,
    Paper,
    Typography,
    CircularProgress,
} from "@mui/material";

import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import TruckCard from "./Card";
import API from "../../services/api-service";
import { useHistory, useLocation } from "react-router-dom";


const Camiones = () => {
    const [truck, setTruck] = useState([]);
    const [loading, setLoading] = useState(true);
    const query = new URLSearchParams(useLocation().search);
    const obteOrganizacion = query.get("organizacion");
    const localizacion = query.get("localizacion")

    const history = useHistory();

    useEffect(() => {
        const fetchCamiones = async () => {
            try {
                const camiones = await API.getCamionesPronaca();
                setTruck(camiones);
            } catch (error) {
                console.error(
                    "Error fetching camiones:",
                    error
                );
            } finally {
                setLoading(false);
            }
        };

        fetchCamiones();
    }, []);

    const irCamion = (camion) => {
        history.push(`/admin/visCamion?organizacion=${obteOrganizacion}&localizacion=${localizacion}`, {
            camion: camion
        });
    };

    return (
        <Main>
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "1400px",
                    margin: "0 auto"
                }}
            >
                {/* ENCABEZADO */}
                <Box
                    sx={{
                        marginBottom: 3,
                    }}
                >
                    <ContenedorTitulo
                        sx={{
                            marginBottom: "6px",
                        }}
                    >
                        <Titulo>Camiones</Titulo>
                    </ContenedorTitulo>
                </Box>

                {/* CONTENEDOR PRINCIPAL */}
                <Paper
                    elevation={0}
                    sx={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "14px",
                        backgroundColor: "#ffffff",
                        overflow: "hidden",
                    }}
                >
                    {/* CABECERA */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            padding: {
                                xs: "18px",
                                md: "20px 24px",
                            },
                            borderBottom:
                                "1px solid #e5e7eb",
                        }}
                    >
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                borderRadius: "9px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#eaf2ff",
                                color: "#1976d2",
                            }}
                        >
                            <LocalShippingIcon />
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    color: "#1f2937",
                                    fontSize: "16px",
                                }}
                            >
                                Vehículos disponibles
                            </Typography>

                            <Typography
                                variant="caption"
                                sx={{
                                    color: "#6b7280",
                                }}
                            >
                                Selecciona un vehículo para
                                consultar sus rutas
                            </Typography>
                        </Box>
                    </Box>

                    {/* CONTENIDO */}
                    <Box
                        sx={{
                            padding: {
                                xs: 2,
                                sm: 3,
                                md: 4,
                            },
                            backgroundColor: "#f8fafc",
                        }}
                    >
                        {loading ? (
                            <Box
                                sx={{
                                    minHeight: 250,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 2,
                                }}
                            >
                                <CircularProgress
                                    size={34}
                                    thickness={4}
                                />

                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "#64748b",
                                    }}
                                >
                                    Cargando camiones...
                                </Typography>
                            </Box>
                        ) : truck.length > 0 ? (
                            <Grid
                                container
                                spacing={{
                                    xs: 2,
                                    sm: 2.5,
                                    md: 3,
                                }}
                            >
                                {truck.map((camion) => (
                                    <Grid
                                        item
                                        key={camion.placa}
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={3}
                                    >
                                        <Box
                                            sx={{
                                                height: "100%",
                                                transition:
                                                    "transform 0.2s ease",
                                                "&:hover": {
                                                    transform:
                                                        "translateY(-3px)",
                                                },
                                            }}
                                        >
                                            <TruckCard
                                                plate={
                                                    camion.placa
                                                }
                                                name={
                                                    camion.nombre
                                                }
                                                onClick={() =>
                                                    irCamion(
                                                        camion
                                                    )
                                                }
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Box
                                sx={{
                                    minHeight: 250,
                                    display: "flex",
                                    flexDirection:
                                        "column",
                                    alignItems: "center",
                                    justifyContent:
                                        "center",
                                    textAlign: "center",
                                    gap: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 56,
                                        height: 56,
                                        borderRadius: "12px",
                                        display: "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",
                                        backgroundColor:
                                            "#eef2f7",
                                        color: "#64748b",
                                        marginBottom: 1,
                                    }}
                                >
                                    <LocalShippingIcon
                                        sx={{
                                            fontSize: 30,
                                        }}
                                    />
                                </Box>

                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        color: "#374151",
                                    }}
                                >
                                    No hay camiones disponibles
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Paper>
            </Box>
        </Main>
    );
};

export default Camiones;